import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: '我應該申請「優才」還是「高才」？',
      answer: '如果您畢業於百強名校或年薪極高，高才通通常更快更直接；如果您學歷優秀但非百強，或擁有豐富管理經驗，優才計劃可能更適合。歡迎聯繫我們進行免費評估。'
    },
    {
      question: '申請需要多長時間？',
      answer: '高才通最快可於4週內獲批，專才一般需4-6週，而優才計劃的審批週期相對較長。我們會協助您準備最完善的文件以加速流程。'
    },
    {
      question: '內地居民可以直接申請投資移民嗎？',
      answer: '不可以。內地居民需先取得第三國永久居民身份才能申請香港的新資本投資者入境計劃。我們可以為您提供相關諮詢。'
    },
    {
      question: '獲批後多久可以申請永久居民身份？',
      answer: '一般情況下，在香港連續通常居住滿7年後，即可申請香港永久性居民身份證。我們會在整個過程中為您提供續簽和轉永居的專業指導。'
    },
    {
      question: '申請被拒後可以重新申請嗎？',
      answer: '可以。但建議先了解被拒原因，並針對性地改善申請材料。我們的專業團隊會協助您分析原因，提高再次申請的成功率。'
    },
    {
      question: '家人可以一起來香港嗎？',
      answer: '可以。獲批後，您的配偶及18歲以下未婚子女可以作為受養人一同來港。我們會協助您辦理相關的受養人簽證申請。'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            常見問題
          </h2>
          <p className="text-xl text-gray-600">
            解答您關於香港移居計劃的疑問
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl border-2 border-gray-200 overflow-hidden hover:border-teal-300 transition-all duration-300"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer hover:bg-gray-50 transition-colors duration-200"
              >
                <span className="text-lg font-bold text-gray-900 pr-4">{faq.question}</span>
                <i className={`ri-arrow-down-s-line text-2xl text-teal-600 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}></i>
              </button>
              
              <div 
                className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`}
              >
                <div className="px-8 pb-6 text-gray-700 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-6">還有其他問題？</p>
          <a 
            href="tel://+85293663961" 
            className="inline-flex items-center px-8 py-4 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            立即諮詢專家
            <i className="ri-customer-service-2-line ml-2 text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
